
export default class AgentDocumentType {
    constructor(jsonResponse) {

        this.name = jsonResponse.name;
        this.displayValue = jsonResponse.displayValue;
    }
}
